module.exports = __webpack_public_path__ + "static/settings-7a8f02feab6755b939d5313294968f3e.png";